import { t } from "i18next";

const CheckMonth = (month: string) => {
  switch (month) {
    case "1":
      return t("january");
    case "2":
      return t("february");
    case "3":
      return t("march");
    case "4":
      return t("april");
    case "5":
      return t("may");
    case "6":
      return t("june");
    case "7":
      return t("july");
    case "8":
      return t("august");
    case "9":
      return t("september");
    case "10":
      return t("october");
    case "11":
      return t("november");
    case "12":
      return t("december");
    default:
      return "-";
  }
};

export default CheckMonth;
